import { render, staticRenderFns } from "./CardRelatorios.vue?vue&type=template&id=bf828e78&scoped=true"
import script from "./CardRelatorios.vue?vue&type=script&lang=js"
export * from "./CardRelatorios.vue?vue&type=script&lang=js"
import style0 from "./CardRelatorios.vue?vue&type=style&index=0&id=bf828e78&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf828e78",
  null
  
)

export default component.exports